module.exports = __webpack_public_path__ + "5a9ad6ae930e6db83414300aafd24b32.jpg";